module.exports = __webpack_public_path__ + "fonts/Gibson-Light.8e19b574.woff";